(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["status-panel-calculator"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-calculate]');
  if (!button) return;
  const root = button.closest('.status-panel-estimator');
  const width = Number(root.querySelector('[data-width]').value);
  const height = Number(root.querySelector('[data-height]').value);
  const output = root.querySelector('[data-result]');
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) { output.textContent = root.dataset.invalid; return; }
  const [pw, ph] = root.querySelector('[data-panel]').value.split(',').map(Number);
  const units = Math.ceil(width / pw) * Math.ceil(height / ph);
  const packs = Math.ceil(units / Number(root.dataset.pack));
  output.textContent = root.dataset.unitsLabel + ': ' + units + '. ' + root.dataset.packsLabel + ': ' + packs + '.';
});
  } catch(e) { console.error(e); }
})();

})();
